import { Box, Flex, Heading, Image, Text, useBreakpointValue } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import bubblesLg from 'src/assets/images/bubbles-lg.svg'
import HowItWorksImg from 'src/assets/images/image3.png'

const HowItWorks = () => {
  const { t } = useTranslation()

  const bgImage = useBreakpointValue({ base: 'none', md: `url(${bubblesLg})` })

  return (
    <Flex
      direction={['column', 'row']}
      p={6}
      id='howItWorksElement'
      backgroundImage={bgImage}
      backgroundPosition='left 20px top 20px'
      backgroundRepeat='no-repeat'
    >
      <Box flex='1' p={5}>
        <Image src={HowItWorksImg} alt='How it works' borderRadius='30px' marginTop={'7rem'} />
      </Box>
      <Box flex='1' p={5} marginTop={'13rem'}>
        <Box position='relative'>
          <Box
            backgroundColor='gray.50'
            borderTopLeftRadius='20px'
            borderTopRightRadius='20px'
            position='absolute'
            top='-9rem'
            left='-20rem'
            right='-5%'
            height='15rem'
            zIndex='-1'
          />
          <Heading fontSize='3em' fontWeight='800' mb={4}>
            {t('homeFooter.title')}
          </Heading>
        </Box>
        <Text fontSize='1.5em' mb={4} marginTop={'4rem'}>
          {t('homeFooter.text1')}
        </Text>
        <Text fontSize='1.5em' mb={4}>
          {t('homeFooter.text2')}
        </Text>
        <Text fontSize='1.5em' mb={4}>
          {t('homeFooter.text3')}
        </Text>
        <Text fontSize='1.5em'>{t('homeFooter.text4')}</Text>
      </Box>
    </Flex>
  )
}

export default HowItWorks
